import React, { useEffect, useReducer, useState } from 'react'
import Table from '../../../Setup/Shared/Table';
import Loader from '../../../shared/Loader/Loader';
import GridColumnHeader from "../../../Setup/Shared/GridColumnHeader"
import Modal from 'react-bootstrap/Modal';
import AddNewDocument from './AddNewDocument';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { useDispatch, useSelector } from 'react-redux';
import isNull from '../../../../utils/NullChecking';
import { PWK } from '../../../../utils/Constants';
import DeleteConfirmatiom from '../../../General/DeleteConfirmation';
import FormValidator from '../../../../utils/FormValidator';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { PracticeID } from '../../../../actions/LoginAction';
import { GeneralDropDowns } from '../../../../actions/GeneralCaregiverActions';
import ModalHeader from '../../../Setup/Shared/ModalHeader';
import { saveAs } from "file-saver"
import handleCopyText from '../../../shared/CopyData';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
const API_URL = enumUtil.controller.General
const API_URL_Wasabi = enumUtil.controller.Wasabi
const Documents = (props) => {
  const API_URL_Caregiver = enumUtil.controller.CareGiver
  let IsEditAllowed = FindFirstChild('CareGiver', 'Documents')?.IsAdd

  let CaregiverIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true))?.data?.id;
  const [modalActive, setModalActive] = useState(false)
  const [documentData, setDocumentData] = useState([])
  const [documentTypeData, setDocumentTypeData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchParam, setSearchParam] = useState();
  const [isClose, setIsClose] = useState();
  const [CaregiverDocumentID, setCaregiverDocumentID] = useState('0')
  const [DocumentTypeID, setDocumentTypeID] = useState('0')
  const [DocumentTypeParentID, setDocumentTypeParentID] = useState('0')
  const [isOpenDocumentType, setIsOpenDocumentType] = useState(false)
  const [pdfFile, setPdfFile] = useState(null);
  const [txtFile, setTxtFile] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [tiffFile, setTiffFile] = useState(null);
  const [isOpenAudit, setisOpenAudit] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const AddDocument = (ID) => {
    console.log("AddDocument", ID)
    setCaregiverDocumentID(ID)
  }
  const DownloadFile = (data) => {
    // let FileName;
    setIsLoading(true)
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      // "ID": CaregiverIDR + "",
      "BucketPath": data.DocumentPath,
      // "Value":"270",
    }, "Download",).then((response) => {
      // ElectronicSubmissiomData.filter((item) => {
      //     if(item.EDIClaimBatchID === BatchID){
      //         FileName = item.FileName
      //     }
      // })
      setIsLoading(false)
      let blob = new Blob([response]);
      saveAs(blob, data.FileName);
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    })
  }
  const [copiedText, setCopiedText] = useState({});


  const handleCopy = (row, type) => {
    let name = `${row}-${type}`;
    console.log("Name", name)
    handleCopyText(type);
    setCopiedText({ ...copiedText, [name]: true });
    setTimeout(() => {
      setCopiedText({ ...copiedText, [name]: false });
    }, 300)
  }
  const columns = [
    {
      key: 'FileName',
      name: (<GridColumnHeader gridHeader={"File Name"} handleGridHeader={() => { }}
        iconName={''} headerName={'File Name'} sortIcon={true} type={'string'} colKey={'FileName'} data={documentData} setData={null} />),
      resizable: true,
      renderCell: ({ row }) => {
        return (
          <button
            className="btn btn-link p-0" onClick={() => AddDocument(row.CareGiverDocumentID)}>
            {row.FileName}
          </button>
        );
      },
    },
    {
      key: 'DocumentType',
      name: (<GridColumnHeader gridHeader={"Doc. Type"} handleGridHeader={() => { }}
        iconName={''} headerName={'Doc. Type'} sortIcon={true} type={'string'} colKey={'DocumentType'} data={documentData} setData={null} />),
      resizable: true,
    },
    {
      key: 'Title',
      name: (<GridColumnHeader gridHeader={"Title"} handleGridHeader={() => { }}
        iconName={''} headerName={'Title'} sortIcon={true} type={'string'} colKey={'Title'} data={documentData} setData={null} />),
      resizable: true,
    },
    {
      key: 'Description',
      name: (<GridColumnHeader gridHeader={"Description"} handleGridHeader={() => { }}
        iconName={''} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={documentData} setData={null} />),
      resizable: true,
      renderCell: ({ row }) => {
        return (
          <>
            <div className="d-flex justify-content-between align-items-center w-100" >
              <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                <div className='copy_icon'>{row.Description}</div>
                <div className="icon_copy">
                  <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.CareGiverDocumentID, row.Description)}></i>
                  <p class="tool_tip xsm_text text-light">Copy</p>
                </div>
                {copiedText[`${row.CareGiverDocumentID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
              </div>
            </div>
          </>
        )
      }
    },
    {
      key: 'Action',
      name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
      resizable: true,
      renderCell({ row }) {
        return (
          <>
            <button className='border-0 no-width ms-2 Sdownload-btn' onClick={() => DownloadFile(row)}>
              <i className="icon-download-svgrepo-com" />
            </button>
            <button className='border-0 bg-transparent' onClick={() => ViewPdf(row)}>
              <i class="icon-Icon-awesome-eye"></i>
            </button>
            <button className='border-0 bg-transparent p-0' onClick={() => DeleteDocument(row)}>
              <i className="icon-delete"></i>
            </button>
          </>
        )
      }
    }
  ]
  const DocumentType = {
    DocumentType: '',
    PWKDocumentType: '',
    DocumentDescription: '',
  }
  let valModal = {}
  let ValidationModal = {
    DocumentTypeVal: '',
  }
  const [isOpenAlert, setisOpenAlert] = useState(false);
  const [del, setDel] = useState(false)
  const [ParentID, setParentID] = useState(false)
  const [DocumetTypeValidationModal, setDocumetTypeValidationModal] = useState(ValidationModal)
  const [mainDocumentModal, setmainDocumentModal] = useState(DocumentType)
  const [DocumentSaveUpdateModal, setDocumentSaveUpdateModal] = useState({})
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  //For Pagination
  const [PerPage, setPerPage] = useState(20);
  const [PageNo, setPageNo] = useState(1);
  const [TotalPages, setTotalPages] = useState();
  const handlePageClick = (page) => { setPageNo(page); }
  const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
  const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
  const handleFingByCreteria = (e) => {
    setPerPage(e.target.value)
    setPageNo(1)
  }
  const API_URL_General = enumUtil.controller.General
  const [isDocumetTypeSaved, setisDocumetTypeSaved] = useState()
  const dispatch = useDispatch();

  /////////////////
  // Find by single Criteria Pateint Documents
  const LoadData = (param) => {
    setIsLoading(true)
    ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
      "TableName": enumUtil.enumAPITableName.CaregiverDocument,
      "SearchParam": param,
      "PerPage": PerPage,
      "PageNo": PageNo,
      "ID": CaregiverIDR + ""
    }).then((response) => {
      setIsLoading(false)
      setDocumentData(response.Rows)
      handleGridHeader({ defaultData: response.Rows })
      setTotalPages(response.count.NumOfPages);
    }).catch((error) => {
      setDocumentData([])
      setIsLoading(false)
    })
  }
  // Find by single Criteria Document Type
  useEffect(() => {
    LoadData();
    setIsLoading(true)
  }, [PerPage, PageNo, isClose])
  const LoadGridDataDD = () => {
    ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
      "TableName": enumUtil.enumAPITableName.DocumentType,
      // "SearchParam": '',
      // "PerPage": PerPage,
      // "PageNo": PageNo,
    }).then((response) => {
      setIsLoading(false)
      setDocumentTypeData(response.Rows)
    }).catch((error) => {
      setIsLoading(false)
    })
    ServerRequestProtected(API_URL_General + "/FillDropdowns", 'post', {
    }).then((response) => {
      dispatch(GeneralDropDowns(response))
      dispatch(PracticeID(response.Practice[0]?.PracticeID))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }
  useEffect(() => {
    LoadGridDataDD()
  }, [isDocumetTypeSaved])
  useEffect(() => {
    if (!isNull(props.Reload)) {
      let data = props.id
      data.map((item) => {
        if (item.key === 214) {
          LoadData()
          LoadGridDataDD()
        }
      })
    }
  }, [props.Reload])
  const ViewPdf = (data) => {
    setPdfFile(null)
    setTxtFile(null)
    setImgFile(null)
    setIsLoading(true)
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      "BucketPath": data.DocumentPath
    }, 'Download').then((response) => {
      setIsLoading(false)
      console.log(response.type);
      if (response.type === 'application/txt') {
        const blob = response;
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result;
          setTxtFile(content);
        };

        reader.readAsText(blob, 'utf-8');
      } else if (response.type === 'application/png') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        setImgFile(objectURL)
      } else if (response.type === 'application/tiff') {

      }
      else {
        let file = new Blob([response]);
        const fileUrl = URL.createObjectURL(file);
        setPdfFile(fileUrl)
      }
      setModalActive(true)
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }
  const DeleteDocument = (data) => {
    console.log("data", data)
    setIsLoading(true)
    ServerRequestProtected(API_URL_Caregiver + "/DeleteCaregiverDocument", 'post', {
      "FilePath": data.DocumentPath,
      "ID": data.CareGiverDocumentID,
      "TableName": enumUtil.enumAPITableName.CaregiverDocument,
    }).then((response) => {
      setIsLoading(false)
      NotificationHandler('Deleted Succesfully', enumUtil.enumtoaster.success);
      setIsClose((Math.random()))
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }
  //handle Change Document Type
  const handleDocumentTypeChange = (e) => {
    let { name, value } = e.target;
    if (process.env.REACT_APP_ISUPPERCASE === "true") {
      value = value.toUpperCase()
    }
    let modal = { ...mainDocumentModal };
    let saveModal = { ...DocumentSaveUpdateModal }
    modal[name] = value
    setmainDocumentModal(modal)
    for (var property in DocumentType) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setDocumentSaveUpdateModal(saveModal)
  }
  // Document Type Validation function
  const DocuumentTypeValidation = async () => {
    let ValidationModal = {
      DocumentTypeVal: FormValidator(
        mainDocumentModal.DocumentType,
        enumUtil.enumValidationType.Required,
        'Document Type',
      ),
    }
    await setDocumetTypeValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  //handle Save Document Type
  const handleSaveDocumentType = async () => {
    if (IsEditAllowed) {
      await DocuumentTypeValidation()
      let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
      if (validation) {
        NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        return
      } else {
        if (DocumentTypeParentID != '0') {
          DocumentSaveUpdateModal['DocumentTypeID'] = DocumentTypeParentID
        }
        let saveModal = {
          TableName: enumUtil.enumAPITableName.DocumentType,
          ID: DocumentTypeID,
          data: { ...DocumentSaveUpdateModal },
        }
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
          .then((response) => {
            if (!isNull(response.id)) {
              setIsLoading(false)
              NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
              setDocumentTypeID(response.id)
              // setmainDocumentModal(DocumentType)
              setDocumentTypeParentID('0')
            }
          }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            console.log('error', error);
          })
      }
    }

  }
  const handleCancel = () => {
    setCaregiverDocumentID('0')
  }
  //handle open Document Type
  const handleOpenDocumentType = (node) => {
    setIsLoading(true)
    setDocumentTypeParentID(node.DocumentTypeID)
    setmainDocumentModal(DocumentType)
    setIsOpenDocumentType(true)
    setIsLoading(false)
    setDocumentTypeID('0')

  }
  // handle Open and Close Delete Document Modal
  let DeleteConfirmation = "";
  const handleDeleteModal = () => {
    setDel(true)
    setisOpenAlert(true)
  }
  const onCloseDelete = () => {
    setisDocumetTypeSaved((Math.random()))
    setisOpenAlert(false)
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = <button className='btn-icon-transparent' onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
  }
  if (isOpenAlert) {
    DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.DocumentType} ID={DocumentTypeID} onClose={onCloseDelete} />
  }
  const handleCloseDocumentType = () => {
    setIsOpenDocumentType(false)
    setisDocumetTypeSaved((Math.random()))
  }

  // Dodument List View Method
  const DocumentList = ({ data }) => {
    const [expandedItems, setExpandedItems] = useState([]);
    const toggleExpand = (parentId) => {
      if (expandedItems.includes(parentId)) {
        setExpandedItems(expandedItems.filter((item) => item !== parentId));
      } else {
        setExpandedItems([...expandedItems, parentId]);
      }
    };
    const getChildren = (parentId) => {
      return data.filter((item) => item.ParentID === parentId);
    };
    const renderChildren = (parentId) => {
      const children = getChildren(parentId);

      if (children.length === 0) {
        return null;
      }
      return (
        <>
          {children.map((child) => (
            <>
              <div className='hk-treeView' key={child.RecordID} style={{ marginLeft: '20px' }}>
                <div className='hk-treeView__head'>
                  <div className='hk-treeView__head__title'>
                    {getChildren(child.DocumentTypeID).length > 0 && (
                      <span onClick={() => toggleExpand(child.DocumentTypeID)}>
                        {expandedItems.includes(child.DocumentTypeID) ? <i className='icon-down-direction'></i> : <i className='icon-right-direction'></i>}
                      </span>
                    )}
                    <span className='hk-treeView__head__title__name'>
                      <i className="icon-Icon-ionic-md-document"></i>
                      {child.DocumentType}
                    </span>
                  </div>
                  <div className='hk-treeView__head__btns'>
                    <button className='btn' onClick={() => handleOpenDocumentType(child)}>
                      <span className="icon" >
                        <i className="icon-Icon-metro-cross"></i>
                      </span>
                    </button>
                    <button className='btn' onClick={() => handleEdit(child)}>
                      <i className='icon-edit-pencil'></i>
                    </button>
                    <button className='btn' onClick={() => handleDelete(child)}>
                      <i className='icon-delete'></i>
                    </button>
                  </div>
                </div>
                {expandedItems.includes(child.DocumentTypeID) && renderChildren(child.DocumentTypeID)}
              </div>
            </>
          ))}
        </>
      );
    };
    const handleEdit = (node) => {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "TableName": enumUtil.enumAPITableName.DocumentType,
        "ID": node.DocumentTypeID + ""
      }).then((response) => {
        setIsOpenDocumentType(true)
        setmainDocumentModal(response)
        setDocumentTypeID(response.DocumentTypeID + "")
        setIsLoading(false)
      }).catch((error) => {
        setIsLoading(false)
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      })
    }
    const handleDelete = (node) => {
      setDocumentTypeID(node.DocumentTypeID)
      setisOpenAlert(true)
    }


    return (
      <>
        {data
          .filter((item) => item.ParentID === "")
          .map((parent) => (
            <>
              <div className='hk-treeView' key={parent.RecordID}>
                <div className='hk-treeView__head'>
                  <div className='hk-treeView__head__title'>
                    {getChildren(parent.DocumentTypeID).length > 0 && (
                      <span onClick={() => toggleExpand(parent.DocumentTypeID)}>
                        {expandedItems.includes(parent.DocumentTypeID) ? <i className='icon-down-direction'></i> : <i className='icon-right-direction'></i>}
                      </span>
                    )}
                    <span className='hk-treeView__head__title__name'>
                      <i className="icon-Icon-ionic-md-document" onClick={() => handleEdit(parent)}></i>
                      {parent.DocumentType}
                    </span>
                  </div>
                  <div className='hk-treeView__head__btns'>
                    <button className='btn' onClick={() => handleOpenDocumentType(parent)}>
                      <span className="icon" >
                        <i className="icon-Icon-metro-cross"></i>
                      </span>
                    </button>
                    <button className='btn' onClick={() => handleEdit(parent)}>
                      <i className='icon-edit-pencil'></i>
                    </button>
                    <button className='btn' onClick={() => handleDelete(parent)}>
                      <i className='icon-delete'></i>
                    </button>
                  </div>
                </div>
                {expandedItems.includes(parent.DocumentTypeID) && renderChildren(parent.DocumentTypeID)}
              </div>
            </>
          ))}
      </>
    );
  };
  const handleAuditModal = () => {
    setisOpenAudit(true)
  }
  const SetPOSName = () => {
    if (mainDocumentModal.DocumentType != null && mainDocumentModal.DocumentType != "") {
      return (
        <p className="heading">{mainDocumentModal.DocumentType}</p>
      )
    } else {
      return (
        <p className="heading">Add New Document Type</p>
      )
    }
  }
  return (
    <div className="hk-docFlex row ar_new-document-design m-0 g-0">
      {isLoading ? <Loader /> : null}
      {/* Document Type Delete Confirmation  */}
      {DeleteConfirmation}
      {/* Document Type List  */}
      <div className="hk-docFlex__sidebar col-md-3 pe-0">
        <div className="hk-docFlex__sidebar__header">
          <button className="btn" onClick={handleOpenDocumentType}>
            Document Types
            <span className="icon">
              <i className="icon-Icon-metro-cross"></i>
            </span>
          </button>
        </div>

        <div className="hk-docFlex__sidebar__content">
          <DocumentList data={documentTypeData ? documentTypeData : []} />
        </div>
      </div >
      {/* Caregiver Document Table and Add New Document Component */}
      <div className="hk-docFlex__content col-md-9 pe-0">
        <div className="row hk-docFlex__content__flex m-0 g-0">
          <div className="doc-table col-md-8 px-0 doc_list ar-no-doc">
            <div className="doc-table__header">
              <p className="heading fs-16">Document Lists</p>
            </div>
            {isLoading ? <Loader /> : null}
            <Table
              columns={columns}
              rows={documentData}
              height='465px'
              dynamicClass='fill-grid DataGrid-Table hk-exp-table patient_doc '
              rowHeight={25}
              PerPage={PerPage}
              PageNo={PageNo}
              TotalPages={TotalPages}
              handlePageClick={handlePageClick}
              PreviousPage={PreviousPage}
              handleFingByCreteria={handleFingByCreteria}
              NextPage={NextPage}
              // hidePagination={true}
              Key={21}
              Name={'CaregiverSearch'}
              hideColClass={'hide'}
            />
          </div>
          <div className="doc-right-col col-md-4 ps-0">
            <div className="upload-box">
              <div className="upload-box__header">
                <p className="heading">Upload Document</p>
                <span className="icon-box">
                  <i className="icon-upload-converted"></i>
                </span>
              </div>
              <AddNewDocument CaregiverDocumentID={CaregiverDocumentID} onCancel={handleCancel} setIsClose={setIsClose} />
            </div>
          </div>
        </div>

      </div>
      {/* Document Type Save and Update Modal */}
      <Modal show={isOpenDocumentType} onHide={() => setIsOpenDocumentType(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal add_doc_types hk-modal-v1">
        <Modal.Body>
          <ModalHeader HeaderName={SetPOSName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={handleCloseDocumentType} key={612} Name={'Documents'} />
          <div className={DocumetTypeValidationModal.DocumentTypeVal ? 'form-group input error' : 'form-group input'}>
            <label htmlFor="DocumentType mb-2">Document Type<span className='req'>*</span></label>
            <input
              type="text"
              className="form-control"
              id="DocumentType"
              name="DocumentType"
              value={mainDocumentModal.DocumentType}
              onChange={handleDocumentTypeChange}
            // placeholder="Type to write"
            />
            {DocumetTypeValidationModal.DocumentTypeVal}
          </div>
          <div className="form-group input">
            <label htmlFor="DocumentDescription">Document Description</label>
            <textarea
              type="text"
              className="form-control"
              id="DocumentDescription"
              name="DocumentDescription"
              value={mainDocumentModal.DocumentDescription}
              onChange={handleDocumentTypeChange}
            />
          </div>
          <div className="form-group input">
            <label htmlFor="PWKDocumentType" className="mb-2">PWK Document Type</label>
            <select
              id='PWKDocumentType'
              name='PWKDocumentType'
              className='form-control fc-xs'
              value={mainDocumentModal.PWKDocumentType}
              onChange={handleDocumentTypeChange}
              placeholder="Type to write" >
              {PWK?.map((e, index) => (
                <option className='listing_ad' value={e.value} key={index}>
                  {e.display}
                </option>
              ))}
            </select>
            {/* <FormControl sx={{ m: 1, minWidth: 190 }} size="small">
              <Select
                className='md-selectbox'
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={mainDocumentModal.PWKDocumentType}
                label="Age"
                onChange={(e) => setmainDocumentModal({ ...mainDocumentModal, PWKDocumentType: e.target.value })}
              >
                {PWK?.map((e, index) => (
                  <MenuItem className='listing_ad' value={e.value} key={index}>
                    {e.display}
                  </MenuItem>
                ))}
              </Select>
             </FormControl> */}
          </div>
        </Modal.Body>
        <div className="btns-group px-3 py-2 br-top-1 br-clr d-flex justify-content-end gap-3">
          <div className="btns-group d-flex justify-content-center align-items-center">
            <button className="btn btn-gray" onClick={() => handleCloseDocumentType()}>
              Cancel
            </button>
            <button className={IsEditAllowed ? "btn btn-orange" : "btn btn-orange disabled"} onClick={handleSaveDocumentType}>
              Save
            </button>
          </div>
        </div>
      </Modal>
      {/* Document PDF Modal */}
      <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1">
        <Modal.Body>
          <div className="download-header">
            <div className='hide-me'></div>
            {/* <button className="btn download-btn">
              Download PDF
            </button> */}

            <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
              <i className="icon-Icon-metro-cross"></i>
            </button>
          </div>
          <div className="pdfView-box">

            {!isNull(txtFile) ? txtFile : ''}
            {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

          </div>
          {isLoading ? <Loader /> : null}

          {pdfFile &&
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfFile}
                  defaultScale={1}
                  plugins={[defaultLayoutPluginInstance]} />
              </Worker>
            </>
          }
        </Modal.Body>
        <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
          <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
        </div>
      </Modal>

    </div>
  )
}
export default Documents